import React, { FC, useEffect, useState } from 'react';
import { tzCorrectedDate } from '../../shared/util/tzCorrectedDate';
import { useTranslation } from '../translations';

interface DateTimeProps {
  readonly value: Date | string;
  readonly timeZone?: string;
}

/** retrieve the date part of a datetime object */
export function getDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export const DateTime: FC<DateTimeProps> = ({ value, timeZone }) => {
  const { ts } = useTranslation();
  const date = new Date(value);
  const isoTime = date.toISOString();
  const formatOpts: Intl.DateTimeFormatOptions = {};
  if (timeZone) {
    formatOpts.timeZone = timeZone;
    formatOpts.timeZoneName = 'short';
  }

  return (
    <time dateTime={isoTime} title={isoTime}>
      {date.toLocaleString(ts('common.locale_code'), formatOpts)}
    </time>
  );
};

interface DateTProps {
  readonly value: Date | string;
  readonly options?: Intl.DateTimeFormatOptions;
  readonly noTimezoneFix?: boolean;
}

export const DateT: FC<DateTProps> = ({ value, options, noTimezoneFix }) => {
  const { ts } = useTranslation();
  const translated = new Date(value);
  const adjustedDate = noTimezoneFix ? translated : tzCorrectedDate(translated);
  return (
    <time dateTime={adjustedDate.toString()} title={adjustedDate.toString()}>
      {adjustedDate.toLocaleDateString(ts('common.locale_code'), options)}
    </time>
  );
};

export const LiveDateTime: FC<{ readonly timeZone?: string }> = ({ timeZone }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return <DateTime timeZone={timeZone} value={currentDate} />;
};
